export class ChangeManagementConstant{

    // Toaster Messages and Severity
    public static readonly Severity_Success: string = 'success';
    public static readonly Severity_Info: string = 'info';
    public static readonly Severity_Err: string = 'error';
    public static readonly Severity_Warning: string = 'warn';
    public static readonly MoveToPreviousPhase_Success: string = 'Change Control has been moved to the previous phase successfully';
    public static readonly PreviousPhase_Phase_Required: string = 'Please select the phase';
    public static readonly PreviousPhase_ReasonForChange_Required: string = 'Please enter the reason';
    public static readonly PreviousPhase_ReasonForChange_Header: string = 'You must enter the reason why the Change Control Version is sent back to a previous phase.';
    public static readonly PreviousPhase_ReasonForChangeInVerificationPhase_Header: string = 'You must enter the reason why the Change Control is sent back to a previous Phase. Note that all selected Action Items will be set back to the Pending Status.';
    
    public static readonly CreateActionItem_Title = 'Create Action Item';
    public static readonly EditActionItem_Title = 'Edit Action Item';

    public static readonly MoveToNextPhase_Success: string = 'Change Control has been moved to the next phase successfully';
    public static readonly ReviewStatusUpdated_Success: string =
    'Change Control Review Updated Successfully';
    public static readonly ApprovalStatusUpdated_Success: string =
    'Change Control Approval Updated Successfully';
    public static readonly VerificationStatusUpdated_Success: string =
    'Change Control Verification Updated Successfully';

    public static readonly MoveToVoidedPhase_Success: string = 'Change Control has been moved to the Voided phase successfully';
    public static readonly MoveToVoidedPhase_Failure: string = 'Failed to move Change Control to Voided phase';

     public static readonly ChangeControlMoveToVoidReason_HeaderText:string="Reason for moving Change Control to Voided Phase"
     public static readonly Reason_Validation_Text:string= "Please enter the reason."
}